import { PosMenu } from './../pos/models/pos-menu.model';
import { HttpClient } from '@angular/common/http';
import { PosProduct } from './../pos/models/pos-product.model';
import { StorageService } from 'src/app/pos/services/storage.service';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { PosBill, PosBillItem } from '../pos/models/pos-bill.model';
import { PosStorageKey } from '../pos/services/storage.key';
import { PosCustomer } from '../pos/models/customer.mode';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { PaymentData } from '../pos/models/pos-customer.model';
import { environment } from 'src/environments/environment';
import { CartService } from '../pos/services/cart.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-pos-customer-display',
  templateUrl: './pos-customer-display.component.html',
  styleUrls: ['./pos-customer-display.component.scss'],
})
export class PosCustomerDisplayComponent implements OnInit {
  @ViewChild('recommendCarousel') recommendCarousel: NgbCarousel;

  imgHost = environment.apiUrl;
  recommendProductList: PosMenu[] = [];
  currentBill: PosBill;
  currentPayment: PaymentData;
  images = [
    'https://picsum.photos/id/944/900/500',
    'https://picsum.photos/id/1011/900/500',
    'https://picsum.photos/id/984/900/500',
  ];
  interval = 6500;
  
  constructor(
    private storageSerice: StorageService, 
    private cdr: ChangeDetectorRef, 
    private http: HttpClient,
    ) {
   
    }

  ngOnInit(): void {
    this.loadRecommendProduct();
    this.loadPosBill();
    this.loadPosPayment();
    this.initListener();
    this.initCarousel();
  }

  initCarousel(): void {}

  loadRecommendProduct(): void {
    console.log('Load recommand product');
    this.recommendProductList = this.storageSerice.getLocal(PosStorageKey.recommend_product) as PosMenu[];
    if (!this.recommendProductList || this.recommendProductList.length === 0) {
      return;
    }
    this.interval = this.recommendProductList[0].pos_product.showtime * 1000;
    console.log('current showtime: ', this.interval);
    if (this.recommendCarousel) {
      this.recommendCarousel.select('recommend-slide-0');
    }
    this.cdr.detectChanges();
  }

  onSlideChange(event) {
    if (!this.recommendProductList || this.recommendProductList.length === 0) {
      return;
    }

    const extractCurrentName = event.current.split('-');
    const target = this.recommendProductList[extractCurrentName[extractCurrentName.length - 1]];
    this.interval = target.pos_product.showtime * 1000;
    console.log('current showtime: ', this.interval);
  }

  loadPosBill(): void {
    // this.currentBill = this.storageSerice.get(PosStorageKey.bill);
    this.currentBill = this.storageSerice.getLocal(PosStorageKey.bill);
    this.cdr.detectChanges();
  }

  loadPosPayment(): void {
    this.currentPayment = this.storageSerice.getLocal(PosStorageKey.cashier);
    if (this.currentPayment) {
      this.currentPayment.customer = {
        ...this.currentPayment.customer,
        phone_hidden: this.currentPayment.customer.phone.replace(/\d{4}$/, 'XXXX'),
        tax_no_hidden: this.currentPayment.customer.tax_no.replace(/\d{4}$/, 'XXXX'),
      };
    }
    this.cdr.detectChanges();
  }

  initListener(): void {
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === `SMART_POS_${PosStorageKey.bill}`) {
        this.loadPosBill();
      }
      if (event.key === `SMART_POS_${PosStorageKey.cashier}`) {
        this.loadPosPayment();
      }
      if (event.key === `SMART_POS_${PosStorageKey.recommend_product}`) {
        setTimeout(() => {
          this.loadRecommendProduct();
        }, 500);
      }
    });
  }

  handleImageError(event): void {
    console.error('Image failed to load:', event);
    const fallbackImageUrl = '../../assets/img/input-cover.png';
    event.target.src = fallbackImageUrl;
  }

}

